import Attachments from './Attachments';
import './Attachments.scss';

export default Attachments;
